/**
 * SLA countdown / overdue helpers shared by ticket list + detail modal.
 *
 * The backend enriches tickets with `sla_hours`, `sla_deadline_at`
 * (ISO string) and `is_overdue` (boolean). This helper turns the deadline
 * into a short human-readable label like "2h 14m left" or "6h overdue"
 * and picks the right accent colour class per priority state.
 */
export const SLA_HOURS = { high: 4, medium: 24, low: 72 };

export function formatSlaLabel(ticket) {
  if (!ticket?.sla_deadline_at) return null;
  const deadline = new Date(ticket.sla_deadline_at).getTime();
  const now = Date.now();
  const diff = deadline - now;
  const absMs = Math.abs(diff);
  const days = Math.floor(absMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((absMs / (1000 * 60 * 60)) % 24);
  const mins = Math.floor((absMs / (1000 * 60)) % 60);

  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0 && days < 3) parts.push(`${hours}h`);
  if (days === 0 && mins > 0) parts.push(`${mins}m`);
  if (parts.length === 0) parts.push("<1m");

  if (ticket.status === "resolved") return `Resolved · SLA ${ticket.sla_hours}h`;
  if (diff < 0) return `${parts.join(" ")} overdue`;
  return `${parts.join(" ")} left`;
}

export function slaToneClass(ticket) {
  if (!ticket) return "";
  if (ticket.status === "resolved") return "border-emerald-500/40 text-emerald-400 bg-emerald-500/5";
  if (ticket.is_overdue) return "border-red-500/60 text-red-400 bg-red-500/10 animate-pulse";
  if (!ticket.sla_deadline_at) return "border-gray-500/40 text-gray-400 bg-gray-500/5";
  const remaining = new Date(ticket.sla_deadline_at).getTime() - Date.now();
  const totalMs = (ticket.sla_hours || 24) * 3600 * 1000;
  const ratio = remaining / totalMs;
  if (ratio < 0.25) return "border-[#d4af37]/60 text-[#d4af37] bg-[#d4af37]/10";
  return "border-emerald-500/30 text-emerald-400 bg-emerald-500/5";
}
